import { UsersService } from "~/entity/Users/api/service";

export const useUsers = () => {
  return {
    getMyUser: UsersService.GET.getMyUser,
    getUserList: UsersService.POST.getUserList,
    exportUserList: UsersService.POST.exportUserList,
    migrateToStaff: UsersService.POST.migrateToStaff,
  };
};
